import Team from "./Team.js";
export default Team;
